export function isFaxSender(commande) {
    const sender = commande?.emailEmetteur?.trim().toLowerCase();
    if (!sender) return false;

    const faxEmails = commande?.ehpad?.emailsFax ?? [];
    return faxEmails.some(email => email?.trim().toLowerCase() === sender);
}

export function isPortalConversation(commande) {
    return commande?.source === "PORTAIL_COLLECTIVITE"
        || commande?.messages?.some(isEhpadAuthoredMessage)
        || false;
}

export function isEhpadAuthoredMessage(message) {
    return message?.idempotencyKey?.startsWith("ehpad-portal-")
        || message?.messageId?.startsWith("ehpad-portal-")
        || message?.sujet === "EHPAD_TO_PHARMACY";
}

export function isPharmacyAuthoredMessage(message) {
    return message?.source === "MANUEL" && !isEhpadAuthoredMessage(message);
}
